import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import debounce from 'lodash/debounce';
import { setMeta } from '../../../features/networkUndoSlice';

export default function handler() {
  const meta = useSelector((state) => state.networkUndo.present.meta); // BUG: not reactive
  const dispatch = useDispatch();
  const [form, setForm] = useState({});

  const debouncedUpdateMeta = useCallback(
    debounce((name, value) => dispatch(setMeta({ ...meta, [name]: value })), 500),
    [meta],
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    debouncedUpdateMeta(name, value);
  };

  const FIELDS = {
    title: 'Title',
    description: 'Description',
    version: 'Version',
    authors: 'Author(s)',
    date_created: 'Date created',
    last_modified: 'Last modified',
  };

  useEffect(() => {
    setForm(meta);
  }, [meta]);

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      {Object.keys(FIELDS).map((key) => (
        <TextField
          fullWidth
          size="small"
          value={form[key] || ''}
          name={key}
          label={FIELDS[key]}
          onChange={handleChange}
          key={key}
        />
      ))}
    </Stack>
  );
}
